<template>
  <div class="row">
    <div class="col-md-5 text-center">{{ name }}</div>
    <div class="col-md-2 text-center">{{ score }}</div>
    <div class="col-md-5 text-center">
      <progress-sparkline :progress="progress" />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import globals from '@/Plugins/globals'
import ProgressSparkline from './progress-sparkline'
export default {
  name: 'challenge-progress',
  components: {
    ProgressSparkline,
  },
  props: {
    row: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    // console.log('Food Progress', this.row)
  },
  computed: {
    progress() {
      let _progress = []
      if (this.row !== undefined && this.row !== null) {
        if (this.row.challenge) {
          if (this.row.challenge.progress.length > 1) {
            _progress = this.row.challenge.progress
          }
        }
      }
      return _progress
    },
    name() {
      // challenge name
      let _data = ''
      if (this.row !== undefined && this.row !== null) {
        if (this.row.challenge) {
          _data = this.row.challenge.name
        }
      }
      return _data
    },
    score() {
      // overall score
      let _data = ''
      if (this.row !== undefined && this.row !== null) {
        if (this.row.overallScore) {
          _data = `${parseFloat(this.row.overallScore, 0).toFixed(2)}%`
        }
      }
      return _data
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-change-red {
  color: red;
  font-weight: 500;
}
</style>
